jQuery(document).ready(function($) {
    $('.facets__form-vertical details').attr('open', 'open');
});


// list and grid view code start
  const singleViewButton = document.querySelector('.single-view-button');
  const listViewButton = document.querySelector('.list-view-button');
  const gridViewButton = document.querySelector('.grid-view-button');
  const SmGridButton = document.querySelector('.sm-grid-view-button');
  const list = document.querySelector('.collection .grid');
  const filterButtons = document.querySelectorAll('.filter-buttons div');
  
  function removeActiveClass() {
    filterButtons.forEach(button => {
      button.classList.remove('active');
    });
  }
  
 if (listViewButton) {
  listViewButton.onclick = function () {
    removeActiveClass();
    list.classList.remove('grid-view-layout', 'sm-grid-view', 'single-view');
    list.classList.add('list-view-layout');
    this.classList.add('active'); // Add active class to the clicked button
  };
}

if (SmGridButton) {
  SmGridButton.onclick = function () {
    removeActiveClass();
    list.classList.remove('list-view-layout', 'sm-grid-view', 'single-view');
    list.classList.add('grid-view-layout');
    this.classList.add('active'); // Add active class to the clicked button
  };
}

if (gridViewButton) {
  gridViewButton.onclick = function () {
    removeActiveClass();
    list.classList.remove('grid-view-layout', 'list-view-layout', 'single-view');
    list.classList.add('lg-grid-view');
    this.classList.add('active'); // Add active class to the clicked button
  };
}

if (singleViewButton) {
  singleViewButton.onclick = function () {
    removeActiveClass();
    list.classList.remove('grid-view-layout', 'list-view-layout', 'sm-grid-view');
    list.classList.add('single-view');
    this.classList.add('active'); // Add active class to the clicked button
  };
}

// list and grid view code start




